
import "../Foundation/stylable/colors.st.css.js";
import "../Text/Text.st.css.js";
import "../Heading/Heading.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_EmptyState";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_EmptyState__root","imageContainer":"wds_1_76_1_EmptyState__imageContainer","childrenContainer":"wds_1_76_1_EmptyState__childrenContainer","container":"wds_1_76_1_EmptyState__container","imageElement":"wds_1_76_1_EmptyState__imageElement","titleContainer":"wds_1_76_1_EmptyState__titleContainer","title":"wds_1_76_1_EmptyState__title","sectionTitle":"wds_1_76_1_EmptyState__sectionTitle","subtitle":"wds_1_76_1_EmptyState__subtitle","subtitleContainer":"wds_1_76_1_EmptyState__subtitleContainer"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




